// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["public/css/app"], () => (__webpack_require__("./src/assets/js/helper.js")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["public/css/app"], () => (__webpack_require__("./src/css/app.css")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
